//@flow
import type { Node } from "react";
import React from "react";

import Layout from '../components/layouts/layout-basic';
import ContactForm from '../components/forms/contact/index';
import { Section, Row, Column } from '../utils/layout/grid';
import PortfolioCallout from '../components/pages/shared/portfolio-callout';
import CaseStudyCarousel from '../components/pages/shared/case-study-carousel';
import { FluidImage } from '../components/ui/images/fluid';
import { useSiteMetadata } from "../utils/graphql/site_metadata";

const RequestEstimate = ():Node => {
  let { lbAppHost } = useSiteMetadata();
  return (
    <Layout pageTitle='Request a Project Estimate' solidMenu onViewEvent="request-estimate" >
      <Section padded>
        <Row>
          <Column readable>
            <div className='text-center'>
              <FluidImage src='illustrations/documents.png' width={320} style={{'margin':'auto'}}/>
            </div>
            <ContactForm formLocation='request-estimate' buttonLabel='Request Estimate'>
              <div className='spaced text-center'>
                <h1>Request an estimate</h1>
                <p>Tell us a little about your project and we'll be in touch.</p>
                <p>If you've already worked with Lightboard or have a detailed brief, images you'd like to attach, or brand guidelines to upload, please <a href={`${lbAppHost}/start`}>start a project</a>.</p>
              </div>
            </ContactForm>
          </Column>
        </Row>
      </Section>
      <Section padded>
        <Row>
          <Column readable textCenter>
            <h1>What's it like working with Lightboard?</h1>
          </Column>
        </Row>
      </Section>
      <Section>
        <Row>
          <Column readable>
            <CaseStudyCarousel/>
          </Column>
        </Row>
      </Section>
      <Section padded>
        <PortfolioCallout/>
      </Section>
    </Layout>
  );
};

export default RequestEstimate;
